import { c as _c } from "react/compiler-runtime";
import { FaroTextMenuButton } from "@components/common/faro-text-menu-button";
import { BulkRemoveMember } from "@components/table/members/bulk-actions/bulk-remove-member";
import { BulkRemoveMemberDialog } from "@components/table/members/bulk-actions/bulk-remove-member-dialog";
import { Text, DeleteIcon, MenuItem } from "@flat-ui";
import { useBulkActionsMode } from "@hooks/use-bulk-actions-mode";
import { useState } from "react";
import { getBulkActionButtonConfig } from "@components/common/faro-table/bulk-actions/bulk-actions-config";
/**
 * Dropdown button for bulk remove member actions.
 * Shows a single "Remove" button that opens a dropdown with multiple remove options
 * (e.g., "Remove from team", "Remove from workspace")
 */
export function BulkRemoveMemberDropdown(t0) {
  const $ = _c(31);
  const {
    companyId,
    teamId,
    availableOptions
  } = t0;
  const mode = useBulkActionsMode();
  const [selectedOption, setSelectedOption] = useState(null);
  if (availableOptions.length === 1) {
    const option = availableOptions[0];
    let t1;
    if ($[0] !== companyId || $[1] !== option.label || $[2] !== option.subjectType || $[3] !== teamId) {
      t1 = <BulkRemoveMember subjectType={option.subjectType} companyId={companyId} teamId={teamId} title={option.label} />;
      $[0] = companyId;
      $[1] = option.label;
      $[2] = option.subjectType;
      $[3] = teamId;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function handleOptionClick(option_0) {
      setSelectedOption(option_0);
    };
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleOptionClick = t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function handleDialogClose() {
      setSelectedOption(null);
    };
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleDialogClose = t2;
  let t3;
  if ($[7] !== mode) {
    t3 = getBulkActionButtonConfig(mode, "Remove members");
    $[7] = mode;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const config = t3;
  let t4;
  if ($[9] !== config.shouldShowText) {
    t4 = config.shouldShowText ? <Text variant="buttonM">Remove</Text> : undefined;
    $[9] = config.shouldShowText;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = config.tooltipText;
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      anchorOrigin: {
        vertical: "top",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "bottom",
        horizontal: "left"
      }
    };
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = config.rippleColor;
  let t8;
  if ($[12] !== config.sx) {
    t8 = () => config.sx;
    $[12] = config.sx;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <DeleteIcon sx={{
      width: "18px",
      height: "18px"
    }} />;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== availableOptions) {
    let t11;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = option_1 => <MenuItem key={option_1.key} label={option_1.label} onClick={() => handleOptionClick(option_1)} />;
      $[17] = t11;
    } else {
      t11 = $[17];
    }
    t10 = availableOptions.map(t11);
    $[15] = availableOptions;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[18] !== config.rippleColor || $[19] !== config.tooltipText || $[20] !== t10 || $[21] !== t4 || $[22] !== t8) {
    t11 = <FaroTextMenuButton buttonTitle={t4} tooltipText={t5} menuPosition={t6} rippleColor={t7} shouldShowEndIcon={false} buttonSx={t8} startIcon={t9}>{t10}</FaroTextMenuButton>;
    $[18] = config.rippleColor;
    $[19] = config.tooltipText;
    $[20] = t10;
    $[21] = t4;
    $[22] = t8;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== companyId || $[25] !== selectedOption || $[26] !== teamId) {
    t12 = selectedOption && <BulkRemoveMemberDialog subjectType={selectedOption.subjectType} companyId={companyId} teamId={teamId} isOpen={true} onClose={handleDialogClose} />;
    $[24] = companyId;
    $[25] = selectedOption;
    $[26] = teamId;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t11 || $[29] !== t12) {
    t13 = <>{t11}{t12}</>;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
}